import { render, staticRenderFns } from "./CallAttention.vue?vue&type=template&id=007dd9b4&scoped=true&lang=pug&"
import script from "./CallAttention.vue?vue&type=script&lang=ts&"
export * from "./CallAttention.vue?vue&type=script&lang=ts&"
import style0 from "./CallAttention.vue?vue&type=style&index=0&id=007dd9b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007dd9b4",
  null
  
)

export default component.exports